module.exports = __webpack_public_path__ + "static/media/DEUS.ce1d426b.png";